import React, {useEffect} from 'react';
import {UiBox, UiCenter, UiImage, UiText} from '~/components/elements';
import {trackPageViewGA} from '~/services/google-analytics';

const RebookingAppointmentSuccess = () => {
  useEffect(() => {
    trackPageViewGA('/rebooking-appointment-success', 'Rebooking Appointment Success');
  }, []);

  return (
    <UiBox px={4}>
      <UiCenter>
        <UiImage type="icon" name="ease-logo" width="120px" mt={6} />
      </UiCenter>
      <UiBox mt="50px">
        <UiText textAlign="center" fontSize={['33px', '40px']} fontWeight="500" mb="20px">
          Your appointment has been confirmed!
        </UiText>
        <UiText textAlign="center" fontSize="md" mt={10}>
          Thank you for using Ease!
        </UiText>
        <UiText textAlign="center" fontSize="md">
          Your appointment has been booked successfully and you’ll receive an email confirming further details shortly.
        </UiText>
        <UiText textAlign="center" fontSize="md" mt={10}>
          If there is anything we can do to help in the meantime, please reach out to us at
        </UiText>
        <UiText textAlign="center" fontSize="md">
          customer.care@ease-healthcare.com.
        </UiText>
        <UiText textAlign="center" fontSize="md" mt={10}>
          The Ease Healthcare Team
        </UiText>
      </UiBox>
    </UiBox>
  );
};

export default RebookingAppointmentSuccess;
